query getCompanyEmailFunnelsStatistics($input: GetEmailFunnelsStatisticsInput!) {
  companyEmailFunnelsStatistics: getCompanyEmailFunnelsStatistics(input: $input) {
    sent
    uniqueOpens
    uniqueLinksClicked
  }
}
